import React from 'react';
import {
  classNames,
  layoutClassNames,
  LayoutClassNameProps,
  textClassNames,
  TextClassNameProps,
} from './classNames';

export interface PlainButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    LayoutClassNameProps,
    TextClassNameProps {}

const PlainButton = React.forwardRef<HTMLButtonElement, PlainButtonProps>(({
  type = 'button',
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textColor,
  textDecoration,
  textReset,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={classNames(
      textClassNames({
        textColor,
        textDecoration,
        textReset,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </button>
));

PlainButton.displayName = 'PlainButton';

export default PlainButton;
